export default __webpack_public_path__ + "static/media/talent-header-bg-svg2-Dev-IT.13316d58.svg";